import baseConfig from './env.json';

export const config = {
  apiHost: baseConfig.api_host,
};
